export enum Challenges {
  skipMAInstallation = 'specs.programs.OOISkipMAInstallationUsers',
  enableUndoButton = 'specs.programs.OOIEnableUndoButton',
  hideStartDate = 'specs.challenges.OOIHideStartDateSelection',
  enableHideTeamEmail = 'specs.challenges.OOIHideSupportEmail',
  showSettingsPanel = 'specs.programs.ShowPaymentPageSettingsStudio',
  enableParticipantPageInEditor = 'specs.programs.EnableParticipantPage',
  redirectToParticipantPage = 'spec.programs.RedirectToParticipantPage',
  enablePremium = 'specs.programs.OOIEnablePremium',
  enableOOIStyleBP = 'specs.programs.OOIStyleBP',
  enableCustomPageInfo = 'specs.programs.EnableEditorCustomPageInfo',
  enableLinksAsBlank = 'specs.programs.OOIEnableLinksAsBlank',
  enableBidirectionalAlignment = 'specs.programs.EnableBidirectionalAlignment',
  handleCustomizedUrlSegments = 'spec.programs.HandleCustomizedUrlSegments',
  enableNewOnboarding = 'specs.programs.OOIEnableNewOnboarding',
  enableCollapsibleSidebar = 'specs.programs.OOIEnableCollapsibleSidebar',
  enableAiChat = 'specs.programs.OOIEnableAiChat',
  disableSeekOnVideo = 'specs.programs.DisableSeekOnVideo',
}
export type ExperimentsKeys = `${Challenges}`;
